export const LayerTypes = {
  point: 'point',
  multipoint: 'multipoint',
  linestring: 'linestring',
  multilinestring: 'multilinestring',
  polygon: 'polygon',
  multipolygon: 'multipolygon',
  geometry: 'geometry',
  wms: 'wms',
  wmsgc: 'wmsgc',
  wmts: 'wmts',
  wfs: 'wfs',
  wcs: 'wcs',
  raster: 'raster'
};

export const StyleTypes = {
  single: 'pojedynczy',
  uniqe: 'unikalny',
  gradual: 'stopniowy'
};